import { spawn } from 'redux-saga/effects';

import dnsSagas from './dns/dnsSagas';
import loadbalancer from './loadbalancer/sagas';
import utilSagas from './util/utilSagas';
import zoneSagas from './zone/zoneSagas';

export default function* networkSagas() {
	yield spawn(dnsSagas);
	yield spawn(loadbalancer);
	yield spawn(utilSagas);
	yield spawn(zoneSagas);
}
